export const i18n = (key) => {
  return TRANSLATIONS[key];
};
const TRANSLATIONS = {
  wa_read: "נקראו",
  wa_delivered: "נמסרו",
  wa_failed: "נכשלו",
  wa_sent: "נשלחו",
};
